import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, message, Input, Button, Table } from "antd";

import {
  req_edit_usm_space_deparrtment,
  req_multiple_employee,
} from "../../api";
import storageUtils from "../../utils/storageUtils";
const { Search } = Input;

class SpaceDepartmentManagerModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    department: {},
    staff: [],
  };

  static propTypes = {
    department: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    const result = await req_edit_usm_space_deparrtment(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_search_item = async (key) => {
    // console.log(key);
    const result = await req_multiple_employee(
      key,
      storageUtils.getUser().token
    );
    console.log(result);
    if (result.data === null) {
      message.success("查無此人");
    } else {
      this.setState({ staff: result.data });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////
  onSearch = (value) => {
    //console.log(value);
    if (value.length >= 1) {
      this.api_search_item(value);
    } else {
    }
  };

  onChange = (staff) => {
    const { Uid } = this.props.department;
    const item = {
      condition: "BASE",
      AgentCode: staff.EmployeeId,
      Uid: Uid,
    };
    this.api_modify_item(item);
    //console.log(item);
  };

  init_columns = () => {
    this.columns = [
      {
        title: "",
        dataIndex: "",
        render: (item) => {
          const { EmployeeId, TwName } = item;
          return (
            <>
              <>
                {EmployeeId}/{TwName}
              </>
              <Button
                type="primary"
                size="small"
                onClick={() => this.onChange(item)}
              >
                <i className="fas fa-user-cog"></i>
                <span style={{ marginLeft: "4px" }}> 接任</span>
              </Button>
            </>
          );
        },
      },
    ];
  };

  ////////////////////////////////////////////////////////////

  render() {
    const { AgentTwName, DepartmentTwName } = this.props.department;
    //console.log(this.props.department);
    const { staff } = this.state;
    return (
      <Card>
        <div className="row">
          <div style={{ fontSize: "1.3em" }}>
            現任管理者：{DepartmentTwName}({AgentTwName})
          </div>{" "}
          <Search
            placeholder="接任者姓名"
            allowClear
            enterButton={
              <>
                <i className="fas fa-search"></i> 查詢
              </>
            }
            size="large"
            onSearch={this.onSearch}
          />
          <Table
            bordered
            scroll={{ y: 380 }}
            dataSource={staff}
            columns={this.columns}
          />
        </div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceDepartmentManagerModal);
